const questions = document.querySelectorAll('.faq-item__question');
if (questions) {
  questions.forEach((question) => {
    question.addEventListener('click', () => {
      const parent = question.closest('.faq-item');
      const answer = parent.querySelector('.faq-item__answer');
      question.classList.toggle('active');
      answer.classList.toggle('active');
    });
  });
}

const topBannerForm = document.querySelector('#top-banner-form');
if (topBannerForm) {
  iFrameResize({ log: false, bodyMargin: '20px 0' }, '#top-banner-form');
}

const bottomForm = document.querySelector('#bottom-form');
if (bottomForm) {
  iFrameResize({ log: false, bodyMargin: '20px 0' }, '#bottom-form');
}

// const openContactModal = document.querySelector('.js-open-contact-modal');
// const contactModal = document.querySelector('#contact-modal-wrapper');

// if (contactModal) {
//   openContactModal.addEventListener('click', (e) => {
//     e.preventDefault();
//     contactModal.classList.add('active');
//   });
// }
